<script>
import axios from 'axios';

export default {
  data: function () {
    return {
      api_url: process.env.VUE_APP_API_BASE_URL,
      isTariffsGet: false,
      freePurposeStayArray: [],
      allowedInnArray: [],
      allowedOrganizationSubjectArray: [],
      allowedRoles: [],
      allowedUserByRole: false,
      allowedVisitorsTransports: [],
      cost: 0,
      tariffs: [],
      isFreeArray: [false, false, false, false]
    }
  },

  watch: {
    'checkForm.visitors': function (visitorId) {
      this.checkFreeVisitors()
    },

    cost(val) {
      this.form.application.cost = val
    },

    'form.application.application_group_purpose_id': function (val) {
      // В заявке выбрана цель «Ввоз/вывоз груза» / «Посещение здания управления»
      this.checkFreeTargets(val)
    },

    'form.application.period_of': function (val) {
      this.getTariffPrice(
        this.getVisitorsTransport(this.form.visitors)
      )
    },

    'form.application.period_to': function (val) {
      this.getTariffPrice(
        this.getVisitorsTransport(this.form.visitors)
      )
    },

    'form.organization.inn': function (val) {
      // Заявка оформлена на организацию из списка бесплатного доступа
      this.checkFreeOrganization(val)
    },

    'form.organization.subject_id': function (val) {
      // Заявителем выступает физическое лицо (выбран соответствующий субъект права)
      this.checkFiz(val)
    },

    'form.visitors': {

      // Заявка оформлена на пешеходный пропуск или на велосипед
      handler: function (val, oldVal) {
        this.checkFreeVisitor(val)
      },
      deep: true
    },

    tariffs(val) {
      this.form.tariffs = val
    }
  },

  created() {
    let _self = this;

    axios.get(
      this.api_url + '/paymentpass/default/get-free-tariff-terms',
      { params: { targetId: this.form.application.id } })
      .then(function (result) {
        if (result && Number(result.status) === 200 && result.data) {
          _self.freePurposeStayArray = result.data.purposeIds
          _self.allowedInnArray = result.data.allowedInns
          _self.allowedOrganizationSubjectArray = result.data.allowedOrganizationSubject
          _self.allowedRoles = result.data.allowedRoles
          _self.allowedUserByRole = !!result.data.allowedUserByRole
          _self.allowedVisitorsTransports = result.data.allowedVisitorsTransports
          _self.isFreeArray = result.data.isFreeArray
          _self.isTariffsGet = true
        }
      })

    _self.isFreeArray = [
      this.freePurposeStayArray.indexOf(this.form.application.application_group_purpose_id?.toString()) > -1,
      this.allowedInnArray.indexOf(this.form.organization.inn) > -1,
      this.allowedOrganizationSubjectArray.indexOf(this.form.organization.subject_id) > -1,
      this.allowedRoles.indexOf(this.form.creatorRole) > -1
    ];
  },

  methods: {
    checkFiz: function (val) {
      // Заявителем выступает физическое лицо (выбран соответствующий субъект права)
      if (this.allowedOrganizationSubjectArray.indexOf(val) > -1) {
        this.cost = 0
        this.isFreeArray[2] = true
        console.log('Бесплатно: ', 'Заявителем выступает физическое лицо')
      } else {
        this.isFreeArray[2] = false
        this.getTariffPrice(
          this.getVisitorsTransport(this.form.visitors)
        )
      }
    },

    checkFreeOrganization: function (val) {
      // Заявка оформлена на организацию из списка бесплатного доступа
      if (this.allowedInnArray.indexOf(val) > -1) {
        this.cost = 0
        this.isFreeArray[1] = true
        console.log('Бесплатно: ', 'Заявка оформлена на организацию из списка бесплатного доступа')
      } else {
        this.isFreeArray[1] = false
        this.getTariffPrice(
          this.getVisitorsTransport(this.form.visitors)
        )
      }
    },

    checkFreeTargets: function (val) {
      val = val.toString()
      // В заявке выбрана цель «Ввоз/вывоз груза» / «Посещение здания управления»
      if (this.freePurposeStayArray.indexOf(val) > -1) {
        this.cost = 0
        this.isFreeArray[0] = true
        console.log('Бесплатно: ', 'В заявке выбрана цель «Ввоз/вывоз груза» / «Посещение здания управления»')
      } else {
        this.isFreeArray[0] = false
        this.getTariffPrice(
          this.getVisitorsTransport(this.form.visitors)
        )
      }
    },

    checkFreeVisitor: function (val) {
      let transports = this.getVisitorsTransport(val)

      if (this.allowedUserByRole && !this.check && !this.view) {
        this.cost = 0
        this.isFreeArray[3] = true
        console.log('Бесплатно: ', ' Заявителем выступает произвольный (не доверенный) пользователь')
      } else {
        this.isFreeArray[3] = false
        this.getTariffPrice(transports)
      }
    },

    checkFreeVisitors: function () {
      this.getTariffPrice(
        this.getVisitorsTransport(this.form.visitors)
      )
    },

    getTariffPrice(transportArray) {
      if (!(this.isFreeArray.indexOf(true) > -1) && this.isTariffsGet) {
        let _self = this;
        let url = this.baseUrl

        axios.post(this.api_url + '/paymentpass/default/get-tariff-price', {
          terminal_id: 1, // МПСП
          term_type_id: _self.form.application.period_count,
          transport_type_id: transportArray,
          date_start: _self.form.application.period_of,
          date_end: _self.form.application.period_to
        }).then(function (result) {
          if (result.status === 200) {
            _self.cost = result.data.cost
            _self.tariffs = result.data.tariffs
          }
        })
      }
    },
    // возвращает массив транспортных средств посетителей
    getVisitorsTransport(visitors) {
      let accessVisitors = visitors.filter(x => x.access === 0)
      let self = this;
      let transportNumbers = [];
      let transports = accessVisitors.map(x => x.transports);
      let transportsArray = transports.map(x => x.map(
        function (y) {
          let num = y.number
          if (num && !transportNumbers.includes(num) && self.allowedVisitorsTransports.length > 0 && !self.allowedVisitorsTransports.includes(y.type)) {
            transportNumbers.push(num)

            return y.type
          }
        }
      ))

      return transportsArray.flat()
    }
  }
}
</script>
